import { render, staticRenderFns } from "./GeneralBilling.vue?vue&type=template&id=224ddbe3"
import script from "./GeneralBilling.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralBilling.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports